import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { take } from 'rxjs';
import { IShopifyProduct, SEO } from '@app/_shared/_models';
import { CollectionService } from '../_shared/_services/collection.service';
import { SeoService } from '../_shared/_services/seo.service';
import { BlogService } from '../_shared/_services/blog.service';
import { BlogTags } from '../_shared/_enums/blog-tags';
import { IBlogPost } from '../blog/_prismic/blog-post';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { ProductCardComponent } from '../_shared/_components/product-card/product-card.component';
import { BlogCardComponent } from '../_shared/_components/blog-card/blog-card.component';

@Component({
    selector: 'app-clear-water-essentials',
    templateUrl: './clear-water-essentials.component.html',
    styleUrls: ['./clear-water-essentials.component.scss'],
    imports: [NgxSkeletonLoaderComponent, ProductCardComponent, BlogCardComponent, RouterLink]
})
export class ClearWaterEssentialsComponent implements OnInit, OnDestroy {
  private readonly collectionService = inject(CollectionService);
  private readonly seoService = inject(SeoService);
  private readonly blogService = inject(BlogService);
  private readonly router = inject(Router);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/logos/main_logo.png',
    metaDescription: 'Cloudy pool or spa water? Shop our best selling water care essentials for chlorine, shock, bromine, cartridges, and more. Free shipping on orders over $60!',
    metaTitle: 'Clear Water Essentials - Best Selling Pool & Spa Water Clarity Products'
  };
  public poolProducts = new Array<IShopifyProduct>();
  public spaProducts = new Array<IShopifyProduct>();
  public blogs = new Array<IBlogPost>();
  public poolLoading = true;
  public spaLoading = true;

  async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/clear-water-essentials');

    this.collectionService.getCollectionProducts('clear-water-essentials-pool')
      .pipe(take(1))
      .subscribe((products: Array<IShopifyProduct>) => {
        this.poolProducts = products;
        this.poolLoading = false;
      });

    this.collectionService.getCollectionProducts('clear-water-essentials-hot-tub')
      .pipe(take(1))
      .subscribe((products: Array<IShopifyProduct>) => {
        this.spaProducts = products;
        this.spaLoading = false;
      });

    this.blogs = await this.blogService.getBlogsByTags([
      BlogTags.POOL_MAINTENANCE,
      BlogTags.BIOGUARD_3_STEP_PROGRAM,
      BlogTags.FOAM_REMOVER,
      BlogTags.SIMPLY_3_STEP
    ]);
  }

  ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
  }

  public async navigate(url: string): Promise<void> {
    await this.router.navigateByUrl(url);
  }
}
